import { NavLink } from 'react-router-dom';
import { SidebarFilters } from '@/components/Layout/SidebarFilters';
import styles from '@/components/Layout/Sidebar.module.css';

const NAV_ITEMS = [{ label: 'Clubs', path: '/' }] as const;

export function Sidebar() {
  return (
    <aside className={styles.sidebar}>
      <div className={styles.brand}>
        <NavLink to="/" className={styles.logo}>
          <span className={styles.logoMark} aria-hidden="true">
            ♠
          </span>
          Poker Grind
        </NavLink>
      </div>

      <nav className={styles.nav} aria-label="Directory navigation">
        <p className={styles.navLabel}>Navigation</p>
        <ul className={styles.navList}>
          {NAV_ITEMS.map((item) => (
            <li key={item.path}>
              <NavLink
                to={item.path}
                end
                className={({ isActive }) =>
                  isActive ? `${styles.navLink} ${styles.navLinkActive}` : styles.navLink
                }
              >
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      <SidebarFilters />
    </aside>
  );
}
